import Color from "@tiptap/extension-color";
import Placeholder from "@tiptap/extension-placeholder";
import TextAlign from "@tiptap/extension-text-align";
import { TextStyle } from "@tiptap/extension-text-style";
import YouTube from "@tiptap/extension-youtube";
import StarterKit from "@tiptap/starter-kit";
import ImageResize from "tiptap-extension-resize-image";

export const defaultTiptapExtensions = [
	StarterKit.configure({
		link: {
			openOnClick: false,
			autolink: true,
			defaultProtocol: "https",
			protocols: ["http", "https"],
		},
	}),
	TextStyle,
	Color.configure({
		types: ["textStyle"],
	}),
	TextAlign.configure({
		types: ["heading", "paragraph"],
		alignments: ["left", "center", "right"],
		defaultAlignment: "left",
	}),
	Placeholder.configure({
		placeholder: "Write your content here...",
	}),
	YouTube.configure({}),
	ImageResize.configure({ allowBase64: false, inline: true }),
];
